import { useState } from 'react';
import axios from 'axios';

import {
  FaUserShield,
  FaUser,
  FaLock
} from 'react-icons/fa';

function Login() {

  const [username, setUsername] =
    useState('');

  const [password, setPassword] =
    useState('');

  const login = async () => {

    try {

      const res =
        await axios.post(
          `${process.env.REACT_APP_API_URL}/admin-login`,
          {
            username,
            password
          }
        );

      if (res.data.success) {

        localStorage.setItem(
          'isLoggedIn',
          'true'
        );

        alert(
          'Login Successful'
        );

        window.location.href =
          '/';

      } else {

        alert(
          res.data.message ||
          'Invalid Credentials'
        );

      }

    } catch (err) {

      console.log(err);

      alert(
        'Unable To Connect Server'
      );

    }

  };

  return (

    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background:
          'linear-gradient(135deg,#6366f1,#8b5cf6,#06b6d4)'
      }}
    >

      <div
        style={{
          width: '420px',
          padding: '40px',
          borderRadius: '30px',
          background:
            'rgba(255,255,255,0.15)',
          backdropFilter:
            'blur(20px)',
          boxShadow:
            '0 8px 32px rgba(0,0,0,0.2)',
          border:
            '1px solid rgba(255,255,255,0.2)'
        }}
      >

        <div
          className="text-center"
        >

          <div
            style={{
              width: '90px',
              height: '90px',
              borderRadius: '50%',
              background:
                'rgba(255,255,255,0.2)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              margin: 'auto',
              marginBottom: '20px'
            }}
          >

            <FaUserShield
              size={45}
              color="#fff"
            />

          </div>

          <h2
            style={{
              color: '#fff',
              fontWeight: '800'
            }}
          >
            Kalyan School ERP
          </h2>

          <p
            style={{
              color: '#e2e8f0'
            }}
          >
            Administrator Login
          </p>

        </div>

        <div className="mt-4">

          <div
            className="input-group mb-3"
          >

            <span
              className="input-group-text"
            >
              <FaUser />
            </span>

            <input
              className="form-control"
              placeholder="Username"
              value={username}
              onChange={(e) =>
                setUsername(
                  e.target.value
                )
              }
            />

          </div>

          <div
            className="input-group mb-4"
          >

            <span
              className="input-group-text"
            >
              <FaLock />
            </span>

            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={password}
              onChange={(e) =>
                setPassword(
                  e.target.value
                )
              }
            />

          </div>

          <button
            className="btn btn-light w-100"
            style={{
              fontWeight: '700',
              padding: '12px'
            }}
            onClick={login}
          >
            Login
          </button>

        </div>

      </div>

    </div>

  );

}

export default Login;